export const pathBuilder = ({ from, path }: { from: string; path: string }) => {
    // Ищем всё включая /from/<id>
    const re = new RegExp(`^.*\\/${from}\\/\\d+`)
    const match = location.pathname.match(re)

    const base = match?.[0] ?? location.pathname

    return `${base}/${path}`
}
